import { quillEmpty } from "@/utils/form";
import { isEmpty } from "lodash";

export default {
    methods: {
        // 验证试题数据完整
        verifyQues(queArr) {
            if (quillEmpty(queArr.Content)) {
                return "请输入试题题干"
            }
            const txt = [1, 2, 4].includes(queArr.SubjectType) ? "选项" : "答案"
            if (isEmpty(queArr.AnswerList)) {
                return "请输入" + txt;
            }
            if (queArr.AnswerList.some(el => quillEmpty(el.Content))) {
                return "请输入" + txt;
            }
            if ([1, 2, 4].includes(queArr.SubjectType) && quillEmpty(queArr.Answer)) {
                return "请选择正确答案";
            }
        },
        // 检查试题数据完整性
        checkQuesData(question) {
            const label = "数据损坏: "
            function printQues(msg) {
                let info = "=== 试题数据损坏 ==="
                info += "\n试题id: " + question.SubjectId;
                info += "\n试题题干: " + question.Content
                info += "\n错误信息: " + msg
                info += "\n试题对象: "
                console.error(info, question, "\n*** 试题数据损坏 ***")
            }
            if (isEmpty(question.AnswerList)) {
                printQues("缺少：AnswerList")
                return false
            }
            if (quillEmpty(question.Content)) {
                printQues("缺少题干：Content")
                return false
            }
            if ([1, 2, 4].includes(question.SubjectType)) {
                if (question.AnswerList.length < 2) {
                    printQues("单选题、多选题、判断题需要最少2个选项")
                    return false
                }
            }
            return true
        }
    },
}
